import { GetQueryByIdParams } from '../../types';
import { ReadAudience } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const getAudienceById = async (
  params: GetQueryByIdParams<ReadAudience>,
): Promise<ReadAudience> => {
  return await tinctApi.audiences.getAudience(params);
};

export const useGetAudienceById = (
  params: GetQueryByIdParams<ReadAudience>,
  options?: Omit<UseQueryOptions<ReadAudience, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['audience', params.id, params.fields],
    queryFn: () => getAudienceById(params),
    ...options,
  });
